import { InjectionToken } from '@angular/core';

export interface AppConfiguration {
  production: boolean;
  angularRootUrl: string;
  apiRootUrl: string;
  applicationInsightsConnString: string;
  appClientId: string;
  apiClientId: string;
  tenantId: string;
  endPoint: string;
  relativeScope: string;
  relativeRedirectUrl: string;
  relativeSilentRenewUrl: string;
}

export const APP_CONFIG = new InjectionToken<AppConfiguration>('APP_CONFIG');
